export enum ECookies {
	COOKIE_CONSENT_PREFERENCE = "SM_COOKIE_CONSENT_PREFERENCE",
	COOKIE_CONSENT_ANALYTICS = "SM_COOKIE_CONSENT_ANALYTICS",
	COOKIE_CONSENT_MARKETING = "SM_COOKIE_CONSENT_MARKETING",
	COOKIE_CONSENT_FUNCTIONAL = "SM_COOKIE_CONSENT_FUNCTIONAL",
}
